export const APPS = {
  accessTokenScopes: 'token_permissions',
  activity: 'activity',
  advancedPaths: 'advanced-paths',
  approval: 'approval',
  autosave: 'autosave',
  bigCommerce: 'storyblok-gmbh@bigcommerce-fieldtypes',
  brokenLinksChecker: 'storyblok-gmbh@broken-links-checker',
  bynder: 'storyblok-gmbh@bynder',
  centra: 'storyblok-gmbh@centra',
  clipboard: 'clipboard',
  cloudinaryAssetManager: 'cloudinary-native',
  codeBlock: 'storyblok-gmbh@code-block',
  colorPicker: 'colorpicker',
  commerceLayer: 'storyblok-gmbh@commerce-layer',
  commercetools: 'storyblok-gmbh@commercetools-fieldtypes',
  contentLocking: 'locking',
  locales: 'locales',
  exportTranslatableFields: 'export',
  importTranslatableFields: 'import',
  netlifyBuilds: 'storyblok-gmbh@netlify',
  nacelle: 'storyblok-gmbh@nacelle-fieldtype',
  optimizely: 'optimizely',
  palette: 'storyblok-gmbh@palette',
  pipelines: 'branches',
  releases: 'releases',
  releasesOnly: 'releases_only',
  renderer: 'renderer',
  replaceAsset: 'replace_asset',
  s3Backups: 'backups',
  saleor: 'storyblok-gmbh@saleor-fieldtypes',
  sap: 'storyblok-gmbh@sap',
  search: 'search',
  semrush: 'storyblok-gmbh@semrush-keywords-app-extension',
  sharedSpace: 'sharedspace',
  shareComponents: 'sharedspace',
  shopify: 'storyblok-gmbh@shopify',
  shopware: 'storyblok-gmbh@shopware-fieldstypes',
  slack: 'storyblok-gmbh@slack',
  smartling: 'storyblok-gmbh@smartling',
  algolia: 'storyblok-gmbh@algolia',
  spryker: 'storyblok-gmbh@spryker-fieldtypes',
  starRating: 'storyblok-gmbh@star-rating',
  tags: 'storyblok-gmbh@tags',
  tasks: 'tasks',
  trashBin: 'trashcan',
  translatableSlugs: 'translatable-slugs',
  vercel: 'storyblok-gmbh@vercel',
  vendure: 'storyblok-gmbh@vendure-fieldtypes',
  seo: 'seo',
  slider: 'storyblok-gmbh@slider',
  salesforce: 'storyblok-gmbh@salesforce',
  sylius: 'storyblok-gmbh@sylius-fieldtypes',
}

export default APPS
